import axios from "axios";
import buildUrl from 'build-url-ts';
import { DataSource, StorageUsage } from 'src/types/settings/dataSource';

const BASE_URL = process.env.REACT_APP_API_URL;
const ASSETS_BASE_URL = `${BASE_URL}/api/2.0/assets`;
const DataSourceApi = `${BASE_URL}/api/2.0/datasources`;

export const dataSourceApi = {
  fetchDataSource: async (): Promise<DataSource[]> => {
    const url = buildUrl(`${DataSourceApi}/summary`);
    const response = await axios.get(url);
    return response.data;
  },
  migrateDataSource: async (sourceId: string): Promise<DataSource> => {
    const url = `${DataSourceApi}/${sourceId}/migrate`;
    const response = await axios.get(url); 
    return response.data;
  },
  createRssDataSource: async (sourceType: string, rssUrl: string): Promise<DataSource> => {
    const url = `${DataSourceApi}/${sourceType}?rssUrl=${encodeURIComponent(rssUrl)}`;
    const response = await axios.post(url);
    return response.data;
  },
  authenticateDataSource: async (sourceType: string, code: string): Promise<any> => {
    const url = `${DataSourceApi}/${sourceType}/authenticate`;
    const { data } = await axios.post(url, null, {
      params: { code },
    });
    return data;
  },
  deleteDataSource: async (sourceId: string): Promise<void> => {
    const url = `${DataSourceApi}/${sourceId}`;
    await axios.delete(url);
  },
  fetchAssetStorageLimit: async (): Promise<StorageUsage> => {
    const url = buildUrl(`${ASSETS_BASE_URL}/storage-limit`);
    const response = await axios.get(url);
    return response.data;
  }
}
